import { IAllPrivateRoutes } from "components/routes/app_routes";
import { user } from "config/roles";
import { CahRecap } from "../screens/mainPages/CashRecap";
import { Remittance } from "../screens/mainPages/Remittance";

export const CashManagementRoutes: IAllPrivateRoutes[] =
     [
        { label: "Cash", pathName: "/cash/recap", routeElement: CahRecap, roles: user.roles },
        { label: "Cash", pathName: "/cash/remittance/*", routeElement: Remittance, roles: user.roles },
      ];